import { useCallback, useState } from 'react'
import { DragDropState, EntityData } from '../types'

interface UseDragAndDropReturn extends DragDropState {
  handleDragStart: (data: EntityData, source: 'left' | 'right') => void
  handleDragEnd: () => void
}

/**
 * Hook for managing drag and drop state in three-way mapping view
 */
export const useDragAndDrop = (): UseDragAndDropReturn => {
  const [isDragging, setIsDragging] = useState(false)
  const [draggedData, setDraggedData] = useState<EntityData | null>(null)
  const [dragSource, setDragSource] = useState<'left' | 'right' | null>(null)

  const handleDragStart = useCallback(
    (data: EntityData, source: 'left' | 'right') => {
      setIsDragging(true)
      setDraggedData(data)
      setDragSource(source)
    },
    [],
  )

  const handleDragEnd = useCallback(() => {
    setIsDragging(false)
    setDraggedData(null)
    setDragSource(null)
  }, [])

  return {
    isDragging,
    draggedData,
    dragSource,
    handleDragStart,
    handleDragEnd,
  }
}
